import { GrowthBook } from '@growthbook/growthbook';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';

const isBrowser = typeof window !== 'undefined';

export const growthbook = new GrowthBook({
    apiHost: process.env.NEXT_PUBLIC_GROWTHBOOK_API_HOST,
    clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY,
    enableDevMode: true,
    trackingCallback: (experiment, result) => {
        console.log('Viewed Experiment', {
            experimentId: experiment.key,
            variationId: result.key,
        });
    },
    plugins: isBrowser ? [autoAttributesPlugin()] : [],
});

export function initGrowthbook() {
    if (!isBrowser) {
        return Promise.resolve();
    }

    return growthbook.init({ streaming: true });
}
